import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../utils/api';
import useSetTitle from './GlobalSetTitleHook';
import axios from 'axios';

const Login: React.FC = () => {
  useSetTitle()
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}api/token/`, values);
      const { refresh, access  } = response.data;
      if (access) {
        localStorage.setItem('token', access); // 保存 token 到 localStorage
        localStorage.setItem('refresh', refresh); // 保存 token 到 localStorage
        message.success('登录成功');
        navigate('/dashboard'); // 重定向到主页面
      } else {
        message.error('登录失败：未返回 token');
      }
    } catch (error) {
      message.error('登录失败，请检查用户名和密码');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '100px auto', padding: '20px', border: '1px solid #d9d9d9', borderRadius: '4px' }}>
      <h2 style={{ textAlign: 'center' }}>CTI AI报告审核系统</h2>
      <Form
        name="login"
        initialValues={{ username: '', password: '' }}
        onFinish={onFinish}
      >
        <Form.Item
          label="用户名"
          name="username"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="密 码"
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;